import styled from 'styled-components';
const Image = /*#__PURE__*/styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1ycnebm-0"
})(["max-width:100%;"]);
/** @component */

export default Image;